export default __webpack_public_path__ + "static/media/DFP-Logo_brand.076d9ee1.png";